import i18n from 'modules/core/lib/i18n'

import { useAccountsPayableUpsellModal } from 'modules/finance/hooks/useAccountsPayableUpsellModal'
import {
  UpsellSourceType,
  accountsPayableUpsellRequestProps,
} from 'modules/finance/lib/upsellUtils'
import UpsellModal from 'modules/upsell/components/UpsellModal'

import imgStep1 from './step1.png'
import imgStep2 from './step2.png'
import imgStep3 from './step3.png'

interface AccountsPayableUpsellModalProps {
  source: UpsellSourceType
}

export const upsellContent = () => {
  const content = [
    {
      title: i18n.t('banking.accounts.upsell.upsell_modal.step_1.title'),
      description: i18n.t('banking.accounts.upsell.upsell_modal.step_1.description'),
      src: imgStep1,
    },
    {
      title: i18n.t('banking.accounts.upsell.upsell_modal.step_2.title'),
      description: i18n.t('banking.accounts.upsell.upsell_modal.step_2.description'),
      src: imgStep2,
    },
    {
      title: i18n.t('banking.accounts.upsell.upsell_modal.step_3.title'),
      description: i18n.t('banking.accounts.upsell.upsell_modal.step_3.description'),
      src: imgStep3,
    },
  ]

  return content
}

export const AccountsPayableUpsellModal = ({ source }: AccountsPayableUpsellModalProps) => {
  const { showAccountsUpsellModal, onClose } = useAccountsPayableUpsellModal(source)

  if (!showAccountsUpsellModal) return null

  return (
    <UpsellModal.Image
      stepsContent={upsellContent()}
      requestDetail={accountsPayableUpsellRequestProps(source)}
      buttonLabel={i18n.t('finance.overview.request_info_button')}
      onClose={onClose}
    />
  )
}
